import JoinOrganization from '../components/JoinOrganization';

import HAPPY from '../img/pages/invite/happy.svg';
import styles from './invite.module.scss';

const Invite = () => {
  return (
    <div className={styles.app}>
      <div className={styles.app__body}>
        <div className={styles.app__body__welcome}>
          <img src={HAPPY} alt="happy" className={styles.app__body__welcome__image} />
          <div className={styles.app__body__welcome__title}>Welcome to [Organization Name]</div>
          <div className={styles.app__body__welcome__text}>
            Get ready to control crypto spend, save time, and automate accounting busywork.
          </div>
        </div>
        <JoinOrganization name="[Organization Name]" members={2} expires={2} />
      </div>
    </div>
  );
};

export default Invite;
